import type { Option } from "@tento-lona/sheets";
import "@tento-lona/sheets-ui/sheet/sheet-element.ts";

import { LonaWebComponent, html } from "@tento-ui/component";
import { component } from "@tento-ui/component-decorators";
import { Style, css } from "@tento-ui/component-styles";
import { SheetElement } from "@tento-lona/sheets-ui/sheet/sheet-element.ts";

/** The `lona-sheet-embed` element: a sheet embedded in a page. */
@component({ name: "lona-sheet-embed" })
export class SheetEmbed extends LonaWebComponent {
  readonly $sheet: SheetElement = this.hydrate("sheet");

  static $styles: Style.Compat[] = [
    css`
      :host {
        display: block;
        height: var(--height, 600px);
        position: relative;
        border-radius: var(--border-radius, 12px);
        overflow: clip;
        background: var(--bg);
        box-shadow: var(--box-shadow);
      }

      #sheet {
        position: absolute;
        inset: 0;
      }
    `,
  ];

  static $html: Option<HTMLTemplateElement> = html`
    <std-sheet id="sheet"></std-sheet>
  `;
}
